/** @jsx jsx */
import { Card, CardComponentProps, forwardRefWithAs, PropsWithAs } from "@eworkit/iris";
import { jsx } from "theme-ui";

export type ResponsiveCardBreakpoint = "md" | "lg";

export interface ResponsiveCardComponentProps extends CardComponentProps {
  breakpoint?: ResponsiveCardBreakpoint;
}

const ResponsiveCardComponent = (
  props: PropsWithAs<ResponsiveCardComponentProps>,
  forwardedRef: React.Ref<HTMLDivElement>,
) => {
  const { as = "div", breakpoint = "lg", ...rest } = props;

  return (
    <Card
      as={as}
      ref={forwardedRef}
      sx={{
        borderRadius: breakpoint === "lg" ? [0, null, null, "lg"] : [0, null, "lg"],
        borderLeftWidth: breakpoint === "lg" ? [0, null, null, "1px"] : [0, null, "1px"],
        borderRightWidth: breakpoint === "lg" ? [0, null, null, "1px"] : [0, null, "1px"],
        px: breakpoint === "lg" ? ["sm", "sm", "sm", "md"] : ["sm", "sm", "md", "md"],
        py: ["md", "md", "md", "md"],
      }}
      {...rest}
    />
  );
};

export type ResponsiveCardProps = PropsWithAs<ResponsiveCardComponentProps, "div">;
export const ResponsiveCard = forwardRefWithAs<ResponsiveCardComponentProps, "div">(ResponsiveCardComponent);
